import i18n from '~/i18n'

export function getTranslationI18n<T extends string>(
    fieldName: T,
    translationObject: Record<string, { [key in T]: string }>
): string {
    let translation: { [key in T]: string } | undefined = translationObject[i18n.language]
    if (!translation?.[fieldName]) {
        translation = Object.values(translationObject)
            .filter((languages) => !!languages[fieldName])
            .at(0)
    }

    return translation?.[fieldName] ?? ''
}
